import { Suspense } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import queryClient from '@/config/queryClient';
import { AuthProvider, SocketProvider, ThemeProvider } from '@/context';
import ErrorBoundary from '@/components/ErrorBoundary';
import PageLoader from '@/components/PageLoader';
import { Toaster } from '@/components/ui/sonner';
import AppRouter from '@/routes/AppRouter';

function App() {
  return (
    <ThemeProvider defaultTheme="system">
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <SocketProvider>
            <BrowserRouter>
              <ErrorBoundary>
                <Suspense fallback={<PageLoader message="Loading page..." />}>
                  <AppRouter />
                </Suspense>
                <Toaster position="top-right" richColors closeButton />
              </ErrorBoundary>
            </BrowserRouter>
          </SocketProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
